import { MotifCard, MotifCardBody, MotifCardFooter } from '@ey-xd/motif-react'
import React from 'react'

const CyberGeneralInfoCard = (props: any) => {
    const { info } = props;
    return (
        <MotifCard className="!h-full">
            <MotifCardBody className="flex flex-col gap-3">
                <div>
                    <h6 className="!font-bold mb-2">General info</h6>
                    {/* <p>
                        Bridgestone Corporation is looking for ESG Data Management & Reporting Solution covering Bridgestone Europe, Middle East and Africa, NV. (BSEMIA), Bridgestone Americas, Inc. (BSAM), Bridgestone Japan (BSJP) and Bridgestone China and Asia Pacific Pte.Ltd. (BSCAP) scope with International Sustainability Standards Board (ISSB) and the Global Reporting Initiative (GRI)
                    </p> */}
                </div>
                <table>

                    {info.map((inf: any, index: number) => {
                        return (
                            <tr key={index}>
                                <td className="!max-w-[14rem]"><h6 className="!font-bold truncate">{inf.label}</h6></td>
                                <td>
                                    <p>
                                        {inf.value}
                                    </p>
                                </td>
                            </tr>
                        )
                    })}
                </table>
            </MotifCardBody>
        </MotifCard>
    )
}

export default CyberGeneralInfoCard